






















































































import { Vue, Component, Watch } from 'vue-property-decorator';
import BaseContainer from '@/components/BaseContainer.vue';
import PWEdit from './component/PWEdit.vue';
import { default as PageDescribe } from '@/components/PageDescribe.vue';
import { formRules } from '@/common/util/validator';
import ButtonPanel from '@/components/ButtonPanel.vue';
import { UserApi } from '@/http';
@Component({
    components: { BaseContainer, PWEdit, ButtonPanel, PageDescribe },
})
export default class Personal extends Vue {
    public $refs: {
        form: HTMLFormElement;
        PWEdit: HTMLFormElement;
    };

    public form = {
        id: '',
        userName: '',
        realName: '',
        phoneNumber: '',
        email: '',
        password: '123456',
        enabled: false,
    };
    public userName = '';
    public phoneNumber = '';
    public status: string = '1';
    // 验证规则
    public formRules = formRules;
    // public passWord: string = '';
    public loading: boolean = false;

    mounted() {
        this.form.id = JSON.parse(sessionStorage.getItem('id') ? sessionStorage.getItem('id') : JSON.parse(localStorage.getItem('mlssloginAd')).id);
        this.loadDetail();
        // this.form.userName = sessionStorage.getItem('userName');
        // this.form.realName = sessionStorage.getItem('realName');
        // this.form.phoneNumber = sessionStorage.getItem('phoneNumber');
        // this.form.password = sessionStorage.getItem('password');
    }

    editManage() {
        // this.$refs.PWEdit.open(this.passWord);
        this.$refs.PWEdit.open(this.form.id);
    }
    public async loadDetail() {
        this.loading = true;
        await UserApi.GetUserDetail(this.form.id)
            .then((res) => {
                if (res) {
                    this.userName = res.userName;
                    this.phoneNumber = res.phoneNumber;
                    this.form = res;
                    this.form.password = '123456';
                    this.loading = false;
                } else {
                    this.loading = false;
                }
            })
            .catch((err) => {
                this.loading = false;
            });
    }
    public save() {
        this.loading = true;
        this.$refs.form.validate((valid) => {
            if (valid) {
                this.form.password = '';
                UserApi.editPersonalInfo(this.form.id, { ...this.form })
                    .then((res) => {
                        this.$message.success('编辑成功!');
                        this.form.password = '123456';
                        this.loading = false;
                    })
                    .catch((err) => {
                        this.form.password = '123456';
                        this.loading = false;
                    });
            } else {
                this.loading = false;
            }
        });
    }
}
